<template>
    <div class="user-search-header">
        <div class="user-search-header__main">
            <h1 class="user-search-header__main-title">Поиск пользователей</h1>
            <div v-if="totalCount" class="user-search-header__main-quantity">
                <div class="user-search-header__main-quantity-number">{{ prettieredQuantity }}</div>
                <div class="user-search-header__main-quantity-subtitle">{{ countedQuantitySubtitle }}</div>
            </div>
        </div>

        <UserSearchNotificationSending :count="totalCount" />

        <div class="user-search-header__underline"></div>
    </div>
</template>
<script>
import strCounter from '@/tools/str_counter';
import { mapActions, mapGetters } from 'vuex';
import { buttonTemplate } from './ButtonTemplate';
import { get, post } from '@/tools/http';
import debounce from '@/tools/debounce';
import gql from 'graphql-tag';
import UserSearchNotificationSending from "@/components/user-search/notification/UserSearchNotificationSending.vue";

export default {
    name: 'UserSearchHeader',
    props: {
        quantity: {
            type: Number,
            default: 0,
        },
        validation: {
            type: Function,
        },
        totalCount: {
            type: Number,
            default: 0,
        },
    },
    components: {
        UserSearchNotificationSending,
    },
    data() {
        return {
            showSendingPopup: false,
            showConfirmPopup: false,
            showDefaultTemplatePopup: false,
            showSendingFooter: false,
            loading: false,
            templates: [
                {
                    type: 'default',
                    name: 'Стандартный шаблон',
                },
                {
                    type: 'ready',
                    name: 'Готовый шаблон',
                },
            ],
            chosenTemplate: '',
            templateTheme: '',
            preview: '',
            currentTemplate: '',
            formData: {
                subject: '',
                htmlText: '',
                link_0_text: '',
                link_0_url: '',
            },
            errors: {
                subject: '',
                htmlText: '',
                link_0_text: '',
                link_0_url: '',
            },
            sendingDocs: {},
            filterQueryToNotify: '',
            readyAttachedFile: '',
            disableDefaultButton: false,
        };
    },
    mounted() {
        console.log(this.userProfileInfo);
    },
    computed: {
        ...mapGetters(['getUsersQueryData', 'userProfileInfo', 'isAuthorized']),

        prettieredQuantity() {
            return this.totalCount.toString().replace(/(?!^)(?=(?:\d{3})+(?:\.|$))/gm, ' ');
        },
        countedQuantitySubtitle() {
            return strCounter('Пользовате', 'ль', 'ля', 'лей')(this.totalCount);
        },
        resultData() {
            const button = this.formData.link_0_url
                ? buttonTemplate
                      .replaceAll(/\{\{ link_0_url }}/g, this.formData.link_0_url)
                      .replaceAll(/\{\{ link_0_text }}/g, this.formData.link_0_text)
                : '';

            return {
                subject: this.formData.subject,
                theme: this.formData.subject,
                htmlText: this.formData.htmlText + button,
            };
        },
    },
    methods: {

        async getEmailTemplate(name) {
            return await get('notify', 'email/templates', { templateName: name }, {}, {});
        },
        async initTemplate() {
            this.loading = true;

            const templateQuryResult = await this.getEmailTemplate('default');
            if (templateQuryResult) {
                this.currentTemplate = templateQuryResult.data;
                this.preview = this.currentTemplate
                    .replace(/{{ theme }}/g, '{{ Title }}')
                    .replace(/{{ text }}/g, '{{ Text }}')
                    .replace(/{{ footer }}/g, '');
            }

            this.loading = false;
        },
        clearErrors() {
            for (const i in this.errors) {
                this.errors[i] = '';
            }
        },
        validate() {
            this.clearErrors();

            let customIsValid = true;

            if (this.validation) {
                customIsValid = this.validation();
            }

            if (this.formData.subject.trim() === '') {
                this.errors.subject = 'Введите тему';
                this.disableDefaultButton = true;
            }

            if (this.formData.htmlText.trim() === '') {
                this.errors.htmlText = 'Введите текст рассылки';
                this.disableDefaultButton = true;
            }

            if (this.formData.link_0_text.trim() !== '' && this.formData.link_0_url.trim() === '') {
                this.errors.link_0_url = 'Введите ссылку';
            } else if (this.formData.link_0_url.trim() !== '') {
                try {
                    new URL(this.formData.link_0_url);
                } catch (_) {
                    this.errors.link_0_url = 'Невалидная ссылка';
                    this.disableDefaultButton = true;
                }
            }

            return customIsValid && !Object.values(this.errors).find((v) => v);
        },
    },
    watch: {
        chosenTemplate: {
            async handler(val) {
                if (val === 'default') {
                    this.closeSendingPopup();
                    this.showDefaultTemplatePopup = true;
                    await this.initTemplate();
                }
            },
        },

        showDefaultTemplatePopup: {
            handler(val) {
                if (val) {
                    document.documentElement.style.overflow = 'hidden';
                } else {
                    document.documentElement.style.overflow = 'scroll';
                }
            },
        },

        formData: {
            async handler(newVal, oldVal) {
                if (newVal.subject === '' || newVal.htmlText === '') {
                    this.disableDefaultButton = true;
                } else {
                    this.disableDefaultButton = false;
                }
                if (oldVal || newVal) {
                    debounce(
                        async () => {
                            this.preview = this.currentTemplate
                                .replace(/{{ theme }}/g, this.resultData.subject || '{{ Title }}')
                                .replace(/{{ text }}/g, this.resultData.htmlText || '{{ Text }}')
                                .replace(/{{ footer }}/g, '');
                        },
                        300,
                        false,
                        'user-mail-send-modal-preview'
                    )();

                    for (const i in newVal) {
                        if (newVal[i] !== oldVal[i] && this.errors[i]) {
                            this.errors[i] = '';
                        }
                    }
                }
            },
            deep: true,
        },
        sendingDocs: {
            handler(val) {
                if (val.files) {
                    this.showSendingFooter = true;
                } else {
                    this.showSendingFooter = false;
                }
            },
            deep: true,
        },
    },
};
</script>
<style scoped lang="scss">
@import '~@/styles/rem';
@import '~@/styles/variables';

.user-search-header {
    width: 100%;

    @include on-desktop {
        position: fixed;
        left: urem(10);
        background: #fff;
        z-index: 998;
    }
    &__main {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: space-between;
        gap: mrem(20);

        @include on-desktop {
            padding: 0;
            width: rem(1608);
            margin: 0 auto;
            min-height: urem(100);
            flex-direction: row;
            align-items: flex-start;
            gap: rem(20);
        }
    }

    &__main-title {
        margin: 0;
        color: $color-secondary-dark_violet;
        @include set-font-size(32, 700, 40);
        @include on-desktop {
            padding: urem(12) 0 0 0;
            @include set-font-size(56, 700, 66);
        }
    }

    &__main-quantity {
        display: flex;
        flex-direction: row;
        justify-items: flex-start;
        align-items: center;
        gap: mrem(12);

        @include on-desktop {
            justify-items: center;
            flex-direction: column;
            gap: rem(10);
        }
    }

    &__main-quantity-number {
        color: $color-secondary-dark_violet;
        font-style: normal;
        font-weight: 800;
        font-size: mrem(20);

        @include on-desktop {
            @include set-font-size(56, 800, 66);
        }
    }

    &__main-quantity-subtitle {
        color: $color-secondary-dark_violet;
        font-style: normal;
        font-weight: 400;
        text-transform: uppercase;
        font-size: mrem(16);
        line-height: mrem(20);

        @include on-desktop {
            font-size: rem(16);
            line-height: rem(20);
        }
    }

    &__underline {
        width: 100%;
        background-color: #848196;
        height: mrem(2);

        @include on-desktop {
            display: none;
            margin-top: 0;
            height: rem(2);
        }
    }
}

</style>
